import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../Common';
import {
    TableContent
} from "../../Common/Table/tableContent";
import services from "../services";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import $ from "jquery";
import authService from "../../Common/services";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { FactoryRouteWeighReportSchemaObject } from "../factoryRouteWeighReportSchema";
import { validateProperty, validate } from "../../Common";
import tokenService from "../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import { CommonEncryptParam } from '../../../../utils/CommonParams';
import MessageModal from '../../../UI/Modal/MessageModal';
import Chip from '@material-ui/core/Chip';
import LineWeightIcon from '@material-ui/icons/LineWeight';


const screenCode = "FALCONTAGAMENDMENT";

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
    dialog1: {
        width: 850,
      }
  });

export function FalconTagAmend(props) {
    const classes = useStyles();
    const componentRef = useRef();
    const [reportData, setReportData] = useState([]);
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [open, setOpen] = React.useState(false);
    const [selectedDialogcontent, setSelectedDialogcontent] = React.useState({
        prevCustomerName:"",
        newCustomerID:"",
        newCardNo:"",
        pcID:"",
        prevCardNo:""
    });
    const [selectedDialogcontent2, setSelectedDialogcontent2] = React.useState({
        pcID:""
    });
    const handleClickOpen = (data) => {
      setOpen(true);
      setSelectedDialogcontent({
        ...selectedDialogcontent,
          prevCustomerName:data.customerName,
          pcID:data.productCollectionID,
          prevCardNo:data.cardNumber
      });
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    
    

    const [leafCollectionVariance, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        date: ""
    });

    const [supplierSelect, setSupplierSelect] = useState({
        routeID: "0",
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        date: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(FactoryRouteWeighReportSchemaObject).options({ allowUnknown: true });



    const [contentRowNames, setContentRowNames] = useState(["cardNumber", "customerName", "collectionPointCode", "collectionPointName", "suppliedQty", "cardReadTime"]);

    const initialCsvHeaders = [
        { label: "Registration Number", value: "cardNumber" },
        { label: "Customer Name", value: "customerName" },
        { label: "Route Code", value: "collectionPointCode" },
        { label: "Route Name", value: "collectionPointName" },
        { label: "Supplied Quantity", value: "suppliedQty" },
        { label: "Date", value: "cardReadTime" }
    ]
    const [csvHeaders, setCsvHeaders] = useState(initialCsvHeaders);
    const [csvData, setCsvData] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [maxWidth, setMaxWidth] = React.useState('sm');
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Success"
    })
    const [open1, setOpen1] = React.useState(false);

    const handleClickOpen1 = (pcid) => {
        setSelectedDialogcontent2({
            ...selectedDialogcontent2,
            pcID:pcid
        });
      setOpen1(true);
    };
  
    const handleClose1 = () => {
      setOpen1(false);
    };

    const [totalNet, setTotalNet] = useState({
        total:0
    }); 

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionVariance.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionVariance.factoryID])


    

    function createData(name, calories, fat, carbs, protein) {
        return { name, calories, fat, carbs, protein };
      }
      
      const rows = [
        createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
        createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
        createData('Eclair', 262, 16.0, 24, 6.0),
        createData('Cupcake', 305, 3.7, 67, 4.3),
        createData('Gingerbread', 356, 16.0, 49, 3.9),
      ];

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            factoryID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: target.value,
        });
        setIsTableHide(true);
    }
    async function handleSupplierRouteChange(target) {
        validateInputs(target);

        setSupplierSelect({
            ...supplierSelect,
            routeID: target.value,
        });
        await getCustomers(target.value);
    }
    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            date: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, FactoryRouteWeighReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFALCONTAGAMENDREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionVariance,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionVariance.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionVariance.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch() {
        //e.preventDefault();
        setIsTableHide(false);
        setReportData([]);
        const errorMessages = validate(schema, leafCollectionVariance);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        var res = await services.getFalconReportData(leafCollectionVariance);
        var total = 0;
        res.forEach(x => {
            total = total + x.suppliedQty;
            x.cardNumber = x.cardNumber;
            x.cardReadTime = x.cardReadTime.split('T')[0];
            x.cardNumber = x.cardNumber;
            x.collectionPointName = x.collectionPointName;
            x.customerName = x.customerName;
            x.suppliedQty = x.suppliedQty;
        })
        setTotalNet({
            total:total
        })
        if (res != null || res.length != 0) {
            setReportData(res);
            setCsvData(res);
            setSupplierSelect({
                routeID:leafCollectionVariance.routeID
            });
            await getCustomers(supplierSelect.routeID);
        }


    }

    function generateCsvData(data, totalRowResult, contentResult) {

        var copyOfData = _.cloneDeep(data);
        var newRecord = { filedDate: "Total" }

        newRecord.fieldNumberOfUnits = totalRowResult.bagCount;
        totalRowResult.forEach(x => {
            newRecord[x.name] = x.value === undefined ? (0).toFixed(2) : x.value.toFixed(2);
        });

        copyOfData.push(newRecord);
        setCsvData(copyOfData);
    }





    function createFile() {
        var settings = {
            sheetName: 'Product Collection Report',
            fileName: 'Product Collection Report',
            writeOptions: {}
        }

        xlsx(csvHeaders, csvData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionVariance,
            routeID: "0",
            date: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            date: searchForm.date
        })
    }

    async function getCustomers(routeID){
        var response = await services.getCustomersFromCollectionPoint(routeID);
        setCustomers(response);
    }

    function handleCustomerAccChange(data){
        if(data!=null||data!=undefined){
            setSelectedDialogcontent({
                ...selectedDialogcontent,
                newCustomerID:data.customerID,
                newCardNo:data.cardNumber
              })
             
        }
      
    }
    function handleEditPageCLick(PcID) {
     
        props.history.push({
            pathname: 'falconTagAmend/addEdit/'+ CommonEncryptParam(PcID.toString()),
            data: null,
            edit: true
        })
    }
    async function handleClickDelete(id){
        handleClose1();
        let obj ={
            productCollectionID:id,
            modifiedBy:1
        }
        var response = await services.deleteTag(obj);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged2(response.statusCode)
      };


      async function UpdateCustomer(){
        handleClose();

        let obj = {
            productCollectionID:selectedDialogcontent.pcID,
            modifiedBy:1,
            cardNumber:selectedDialogcontent.newCardNo,
            oldCardNumber:selectedDialogcontent.prevCardNo,
            customerID:selectedDialogcontent.newCustomerID,
            collectionPointID:parseInt(supplierSelect.routeID),
            oldCollectionPointID:parseInt(leafCollectionVariance.routeID)
        }
        var response = await services.updateCustomer(obj);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

      function afterSuccessfulyChanged(response) {
        if (response === "Success") {
         handleSearch()
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 3000);
    }

    function afterSuccessfulyChanged2(response) {
        if (response === "Success") {
            handleSearch()
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 3000);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Falcon Leaf Amendment"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch()}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionVariance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionVariance.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route*</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionVariance.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionVariance)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                            <br/>
                                                <Chip
                                                    icon={<LineWeightIcon />}
                                                    label={"Total Net : " + totalNet.total} 
                                                    color="secondary"
                                                    variant="outlined"
                                                />
                                                <br/>
                                                <br/>
                                                <TableContainer component={Paper}>
                                                    <Table className={classes.table} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>Registration</TableCell>
                                                                <TableCell align="center">Supplier Name</TableCell>
                                                                <TableCell align="center">Route Code</TableCell>
                                                                <TableCell align="center">Route Name</TableCell>
                                                                <TableCell align="center">Narration</TableCell>
                                                                <TableCell align="center">Supplied Quantity</TableCell>
                                                                <TableCell align="center">Supplier Date</TableCell>
                                                                <TableCell align="center">Actions</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                      
                                                            {reportData.map((row) => (
                                                                <TableRow key={row.cardNumber}>
                                                                    <TableCell component="th" scope="row">
                                                                        {row.cardNumber}
                                                                    </TableCell>
                                                                    <TableCell  component="th" scope="row" align="right"> {row.customerName}</TableCell>
                                                                    <TableCell  component="th" scope="row" align="right"> {row.collectionPointCode}</TableCell>
                                                                    <TableCell  component="th" scope="row" align="right"> {row.collectionPointName}</TableCell>
                                                                    <TableCell  component="th" scope="row" align="right"> {row.narration}</TableCell>
                                                                    <TableCell  component="th" scope="row" align="right"> {row.suppliedQty}</TableCell>
                                                                    <TableCell  component="th" scope="row" align="right"> {row.cardReadTime}</TableCell>
                                                                    <TableCell align="center">
                                                                        <IconButton aria-label="delete" className={classes.margin} onClick={e=>handleClickOpen(row)}>
                                                                            <AccountBoxIcon fontSize="small" />
                                                                        </IconButton>
                                                                        <IconButton aria-label="delete" className={classes.margin} onClick={e=>handleEditPageCLick(row.productCollectionID)}>
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                        <IconButton aria-label="delete" className={classes.margin} onClick={e=>handleClickOpen1(row.productCollectionID)} >
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                            )}

                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                        </div>
                                    </div>

                                 
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={maxWidth}
            >
                <DialogTitle id="alert-dialog-title">{"Update Customer"}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item  xs={4}>
                        <InputLabel htmlFor="max-width">Previouse Supplier</InputLabel>
                                <TextField 
                                fullWidth 
                                inputProps={{ style: { textAlign: 'center' } }} 
                                id="outlined-basic" 
                                
                                disabled name="customerNo" 
                                value={selectedDialogcontent.prevCustomerName} 
                                size="small" 
                                label="" 
                                variant="outlined" 
                            />
                            
                        </Grid>
                        <Grid item xs={4}>
                        <InputLabel htmlFor="max-width">Route*</InputLabel>
                                        <Select
                                            fullWidth
                                            size="small"
                                            id="routeID"
                                            label="" 
                                            
                                            name="routeID"
                                            value={supplierSelect.routeID}
                                            onChange={(e) => handleSupplierRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                        </Grid>
                        <Grid item  xs={4}>
                            <InputLabel htmlFor="max-width">New Supplier</InputLabel>
                            <Autocomplete
                                required
                                fullWidth
                                size="small"
                                name="customerNo"
                                onChange={(e, value) => handleCustomerAccChange(value)}
                                classes={classes.autoComplete}
                                options={customers}
                                getOptionLabel={(option) => option.customerName + "--" + option.customerRegistrationNumber}
                                renderInput={(params) => <TextField {...params} fullWidth label="Supplier" variant="outlined" id="outlined-basic" name="customerNo" />}
                            />
                        </Grid>
                    </Grid>


                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={()=>UpdateCustomer()} color="primary" autoFocus>
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{" Do you want to delete this transaction?"}</DialogTitle>
             
                <DialogActions>
                    <Button onClick={handleClose1} color="primary">
                        No
                    </Button>
                    <Button onClick={e=>handleClickDelete(selectedDialogcontent2.pcID)} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
        </Fragment>
    );
}
